import React from 'react'
import PermissionsForm from './PermissionsForm'

const NewPermissionPage = () => {
  return (
    <>
     <PermissionsForm formType='create' currentPermissionId={null} ></PermissionsForm>
    </>
  )
}

export default NewPermissionPage
